import { KeyboardEvent } from 'react';

const preventMultiValueArrowNav = (e: KeyboardEvent) => {
  if ((e.key === 'ArrowLeft' || e.key === 'ArrowRight') && e.target instanceof HTMLInputElement && !e.target.value) {
    e.preventDefault();
  }
};

export default preventMultiValueArrowNav;
